var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTileLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "course-management-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.181,
    height: 57.534,
    viewBox: "0 0 69.181 57.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64990",
    "data-name": "Path 64990",
    d: "M603.73,57.621a2.655,2.655,0,0,1-1.426-.416,27.191,27.191,0,0,0-29.021,0,2.662,2.662,0,0,1-4.088-2.246V7.378a2.662,2.662,0,0,1,1.235-2.246,32.406,32.406,0,0,1,34.727,0,2.662,2.662,0,0,1,1.235,2.246V54.959A2.662,2.662,0,0,1,603.73,57.621ZM574.519,8.882V50.511a32.412,32.412,0,0,1,26.55,0V8.882a27.226,27.226,0,0,0-26.55,0Z",
    transform: "translate(-537.211 -0.088)",
    fill: "#c3288a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64991",
    "data-name": "Path 64991",
    d: "M34.536,57.623a2.656,2.656,0,0,1-1.426-.416,27.191,27.191,0,0,0-29.022,0A2.662,2.662,0,0,1,0,54.961V7.38A2.662,2.662,0,0,1,1.236,5.134a32.405,32.405,0,0,1,34.726,0A2.662,2.662,0,0,1,37.2,7.38V54.961A2.662,2.662,0,0,1,34.536,57.623ZM18.6,47.669a32.35,32.35,0,0,1,13.275,2.843V8.884a27.219,27.219,0,0,0-26.551,0V50.513A32.35,32.35,0,0,1,18.6,47.669Z",
    transform: "translate(0 -0.09)",
    fill: "#c3288a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64992",
    "data-name": "Path 64992",
    d: "M180.925,71.08H169.28a2.662,2.662,0,1,1,0-5.324h11.646a2.662,2.662,0,1,1,0,5.324Zm0,11.868H169.28a2.662,2.662,0,1,1,0-5.324h11.646a2.662,2.662,0,1,1,0,5.324Zm31.834-15.1a2.662,2.662,0,0,1-1.5-.463l-3.643-2.482-3.643,2.482a2.662,2.662,0,0,1-4.159-2.2V50.863a2.662,2.662,0,1,1,5.324,0v9.292l.981-.665a2.662,2.662,0,0,1,2.995,0l.981.665V50.863a2.662,2.662,0,1,1,5.324,0V65.189a2.662,2.662,0,0,1-2.662,2.662Z",
    transform: "translate(-157.255 -45.498)",
    fill: "#c3288a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileLogo2);
export default __webpack_public_path__ + "static/media/tile-logo2.77abf0ec3ec82a76f4a50840268aac22.svg";
export { ForwardRef as ReactComponent };